var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3532 24.4368C1.71008 24.4368 1.15934 24.2076 0.70097 23.7492C0.243381 23.2916 0.0145874 22.7413 0.0145874 22.0982V5.72788C0.0145874 5.08476 0.243381 4.53402 0.70097 4.07565C1.15934 3.61806 1.71008 3.38926 2.3532 3.38926H12.7893L10.4506 5.72788H2.3532V22.0982H18.7235V13.9715L21.0621 11.6329V22.0982C21.0621 22.7413 20.8333 23.2916 20.3757 23.7492C19.9173 24.2076 19.3666 24.4368 18.7235 24.4368H2.3532ZM15.4202 4.06162L17.0865 5.69864L9.36903 13.4161V15.0823H11.0061L18.7527 7.33567L20.419 8.9727L12 17.4209H7.03042V12.4514L15.4202 4.06162ZM20.419 8.9727L15.4202 4.06162L18.3435 1.13835C18.8112 0.670629 19.3717 0.436768 20.0249 0.436768C20.6774 0.436768 21.2277 0.670629 21.676 1.13835L23.313 2.80461C23.7612 3.25285 23.9854 3.79852 23.9854 4.44164C23.9854 5.08476 23.7612 5.63043 23.313 6.07867L20.419 8.9727Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.98a314a4c0552d1659d015a2313a8b15.svg";
export { ForwardRef as ReactComponent };